export default __webpack_public_path__ + "static/cafe_36037-aefa9015289f1ed8af46ace679090832.png";